

































import { Component, Vue, Prop, Model } from 'vue-property-decorator';
import { ELabelSize, BaseLabel } from '../base-label';
import Check from './assets/check.svg';

@Component({
  name: 'BaseCheckbox',
  components: {
    Check,
    BaseLabel,
  },
  data: () => ({
    ELabelSize,
  }),
})
export default class BaseCheckbox extends Vue {
  @Model('change') checked: boolean;
  @Prop({ default: false }) indeterminate: boolean;
  @Prop({ default: false }) error: boolean;
  @Prop() disabled: boolean;
  @Prop() label?: string;
  @Prop() id?: string;
  @Prop({ default: ELabelSize.Medium }) labelSize?: ELabelSize;

  handleClick() {
    if (this.disabled) {
      return;
    }
    this.$emit('change', !this.checked);
  }

  handleFocus() {
    this.$emit('focus');
  }

  handleBlur() {
    this.$emit('blur');
  }

  get checkboxId(): string {
    return this.id || `input-checkbox-${this['_uid']}`;
  }
  get checkboxLabelId(): string {
    return `input-checkbox-label-${this['_uid']}`;
  }

  get ariaChecked(): string {
    if (this.checked) {
      return 'true';
    }

    if (this.indeterminate) {
      return 'mixed';
    }

    return 'false';
  }
}
